import { actionsFactory, props } from '@ngneat/effects';
import { Theme } from '@tmx/modus-operandi';

import { LicenseProduct } from '../../models/license-product';

const amsActions = actionsFactory('ams');

export const initializeAms = amsActions.create('Initialize AMS');

export const loadAccountSummary = amsActions.create('Load Account Summary');

export const checkHasAssets = amsActions.create('Check Has Assets');

export const loadWebToolItems = amsActions.create('Load WebTool Items');

export const initPrimaryNavOptions = amsActions.create(
  'Init Primary Nav Options'
);

export const setLicenseProductRowsDescriptor = amsActions.create(
  'Set License Product Rows Descriptor To Loading Or Use Current License Product Data',
  props<{ licenseProductList: LicenseProduct[]; loading: boolean }>()
);

export const switchAccountResetAms = amsActions.create(
  'Switch Account Reset Ams'
);

export const setBrazeCustomAttributes = amsActions.create(
  'Set Braze Custom Attributes'
);

export const initBrazeInAppMessages = amsActions.create(
  'Init Braze In App Messages'
);

export const openBrazeSession = amsActions.create('Open Braze Session');

export const loadUserInfo = amsActions.create('Load User Info');

export const setBrazeAttribute = amsActions.create(
  'Set Braze Attribute',
  props<{ key: string; value: boolean | number | string }>()
);

export const setTheme = amsActions.create(
  'Set Theme',
  props<{ theme: Theme }>()
);

export const setOnboardingShifted = amsActions.create(
  'Set Onboarding Shifted',
  props<{ shifted: boolean }>()
);
